import * as React from 'react';
/**
 * Store a value in state based on the specified media queries.
 * @param {Array<string>} queries
 * @param {Array<T>} values
 * @param {T} defaultValue
 */
function useMedia(queries, values, defaultValue) {
    const mediaQueryLists = React.useRef([]);
    const handleChange = React.useCallback(() => setValue(getValue), [queries, values]);
    const [value, setValue] = React.useState(getValue);
    React.useEffect(() => {
        // Setup media query lists.
        mediaQueryLists.current = queries.map((query) => window.matchMedia(query));
        // Call handler on hydration.
        handleChange();
        // Setup change handlers.
        mediaQueryLists.current.forEach((mql) => mql.addEventListener('change', handleChange));
        // Remove old change handlers when unmounted.
        return () => {
            mediaQueryLists.current.forEach((mql) => mql.removeEventListener('change', handleChange));
        };
    }, [queries, values]);
    return value;
    /**
     * Get value for current media query, or default value.
     * @returns
     */
    function getValue() {
        const index = mediaQueryLists.current.findIndex((mql) => mql.matches);
        return typeof values[index] !== 'undefined' ? values[index] : defaultValue;
    }
}
export default useMedia;
